import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=1401d772&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=1401d772&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401d772",
  null
  
)

export default component.exports